import {calculateScore} from "./calculateScore";
import {calculateCompletionStatus} from "./calculateCompletionStatus";
import {calculateProgressMeasure} from "./calculateProgressMessure";
import {calculateSuccessStatus} from "./calculateSuccessStatus";

export const StatusCalculator = {

    calculateStatus: ( courseStatus, masteryScore ) =>{
        const completionStatus = calculateCompletionStatus(courseStatus);
        return {
            score: calculateScore(courseStatus),
            completionStatus: completionStatus,
            successStatus: calculateSuccessStatus( courseStatus, masteryScore, completionStatus ),
            exitStatus: (completionStatus === "completed") ? "normal" : "suspend",
            progressMeasure: calculateProgressMeasure(courseStatus)
        };
    }
};
